import type { FaireProductEntity } from "../../entity_types/product";

export const p_caty86ww2c: FaireProductEntity = {
  token: "p_caty86ww2c",
  type: "product",
  name: "Good Luck Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e55a9fbca633e853ab55006c1ae41a5929d587c2c78d33c8948a84d9e28fafc9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/199da2283408cd2139b9265b99c801ca0e4904cdffbffc64c81a202040f7e0b9.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:15.984Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
